import script from "./IntervalReservationApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntervalReservationApp.vue?vue&type=script&setup=true&lang=ts"

import "./IntervalReservationApp.vue?vue&type=style&index=0&id=4c945bad&lang=scss"

const __exports__ = script;

export default __exports__